/**
 * Normaliza valores de imagem que podem chegar como URL, data URL ou base64 puro.
 *
 * Base64 de JPEG começa com `/9j/`, então testar apenas `startsWith('/')` para
 * detectar caminho de arquivo marca essas imagens como URL e quebra o preview.
 */

const URL_PREFIXES = ['http://', 'https://', 'blob:', 'data:'];
const BASE64_PATTERN = /^[A-Za-z0-9+/\s]+={0,2}$/;

function isRawBase64(value) {
    return value.length > 100 && BASE64_PATTERN.test(value);
}

/** Valor pronto para o atributo `src` de uma `<img>`. */
export function toImageSrc(value, mimeType = 'image/jpeg') {
    if (!value || typeof value !== 'string') return undefined;
    if (URL_PREFIXES.some(prefix => value.startsWith(prefix))) return value;
    if (isRawBase64(value)) return `data:${mimeType};base64,${value}`;
    if (value.startsWith('/')) return value;
    return `data:${mimeType};base64,${value}`;
}

/** Valor pronto para a função CSS `url()`. */
export function toImageCssUrl(value, mimeType = 'image/jpeg') {
    const src = toImageSrc(value, mimeType);
    return src ? `url("${src}")` : undefined;
}
